import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';

export type ResponseSelectDataProps = {
  key: string;
  label: string;
};

type AdminUsersApiResponse = {
  success: boolean;
  message: string;
  data: ResponseSelectDataProps[];
};

// Superadmini (users.isAdmin) do selectów — v3-getAdminUsers.
export const useGetAdminUsers = (
  options?: UseQueryOptions<ResponseSelectDataProps[], AxiosError>,
): UseQueryResult<ResponseSelectDataProps[], AxiosError> => useQuery<
  ResponseSelectDataProps[],
  AxiosError
>({
  queryKey: ['admin-users'],
  queryFn: async (): Promise<ResponseSelectDataProps[]> => {
    const res = await axiosInstance.get<AdminUsersApiResponse>('/v3-getAdminUsers');
    return res.data.data;
  },
  staleTime: 5 * 60 * 1000,
  ...options,
});
